import { IdMap, RArray, RMap } from "../collections";
import { makeImmutable } from "../core";
export class PTemporairlyUnavailableIngredients {
    constructor(items) {
        this.items = items;
        makeImmutable(this);
    }
    static fromInstances(modifierType, modifierItemInstances) {
        const items = RMap.singleton(modifierType.id, {
            modifierType,
            unavailableItems: IdMap.fromIterable(new RArray(modifierItemInstances).mapOptional((modifierItemInstance) => {
                const modifierItemType = modifierItemInstance.modifierItemType;
                if (modifierItemType.domain.availabilitySpec.type ===
                    "TemporarilyUnavailable" &&
                    modifierItemInstance.domain.isDefault) {
                    return modifierItemType;
                }
                return null;
            })),
        });
        return new PTemporairlyUnavailableIngredients(items);
    }
    get alerts() {
        return this.items.values.mapOptional(({ modifierType, unavailableItems }) => {
            if (unavailableItems.isEmpty) {
                return null;
            }
            return {
                modifierTypeName: modifierType.name,
                unavailableItemNames: unavailableItems.objects.map((itemType) => itemType.name).raw,
            };
        }).raw;
    }
    static empty() {
        return new PTemporairlyUnavailableIngredients(RMap.empty());
    }
    union(other) {
        const items = this.items.unionWithKey(other.items, (_, { modifierType, unavailableItems: itemsA }, { unavailableItems: itemsB }) => ({ modifierType, unavailableItems: itemsA.union(itemsB) }));
        return new PTemporairlyUnavailableIngredients(items);
    }
}
